export module gcManagementEnumerations {

export class EnumerationModel {
    constructor(public code: string, public name: string) {
    }
}

export class RecurringClassEnds {
    static readonly never = new EnumerationModel('never', 'Never');
    static readonly onDate = new EnumerationModel('ondate', 'On date');
    static readonly afterXOccurrences = new EnumerationModel('afterxoccurrences', 'After X occurrences');
}

export class BookingPresenceStatus {
    static readonly present = new EnumerationModel('present', 'Present');
    static readonly noShow = new EnumerationModel('no-show', 'No-Show');
}

export class GroupClassBookingStatus {
    static readonly active = new EnumerationModel('active', 'Active');
    static readonly cancelled = new EnumerationModel('cancelled', 'Cancelled');
}

export class LocationResourceStatus {
    static readonly active = new EnumerationModel('active', 'Active');
    static readonly inactive = new EnumerationModel('inactive', 'Inactive');
}

export class GroupClassBookingWindowUnit {
    static readonly days = new EnumerationModel('days', 'Days');
    static readonly hours = new EnumerationModel('hours', 'Hours');
}

export class GroupClassCategoryGroup {
    static readonly groupFitness = new EnumerationModel('groupfitness', 'Group Fitness');
    static readonly sports = new EnumerationModel('sports', 'Sports');
    static readonly training = new EnumerationModel('training', 'Training');
    static readonly kids = new EnumerationModel('kids', 'Kids');
    static readonly events = new EnumerationModel('events', 'Events');
}

export class GroupClassStatus {
    static readonly active = new EnumerationModel('active', 'Active');
    static readonly cancelled = new EnumerationModel('cancelled', 'Cancelled');
}
}
